

import VueDraggableResizable from 'vue-draggable-resizable'

import AccountBox from 'vue-material-design-icons/AccountBoxOutline.vue'

import { t } from '@nextcloud/l10n'

import NcButton from '@nextcloud/vue/dist/Components/NcButton.js'

import VideoVue from './VideoVue.vue'

export default {
	name: 'PresenterOverlay',

	components: {
		AccountBox,
		VueDraggableResizable,
		NcButton,
		VideoVue,
	},

	props: {
		token: {
			type: String,
			required: true,
		},

		model: {
			type: Object,
			required: true,
		},

		sharedData: {
			type: Object,
			required: true,
		},

		isCollapsed: {
			type: Boolean,
			required: true,
		},
	},

	emits: ['click'],

	data() {
		return {
			presenterOverlaySize: 128,
			isDragging: false,
		}
	},

	mounted() {
		window.addEventListener('resize', this.updateSize)
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.updateSize)
	},

	methods: {
		t,
		updateSize() {
			this.presenterOverlaySize = Math.min(Math.max(window.innerWidth * 0.1, 100), 242)
		},
	},
}
